export default __webpack_public_path__ + "static/media/decrease.12217b1b.svg";